import React from 'react';
import SectionHeader from './SectionHeader';

const RYG_LABELS = { red: 'Red', yellow: 'Yellow', green: 'Green' };
const PORTFOLIO_LABELS = {
  annually: 'Annually',
  quarterly: 'Quarterly',
  monthly: 'Monthly',
  weekly: 'Weekly',
  daily: 'Daily',
};

function rygBadge(value) {
  if (!value) return <span className="text-muted">Not answered</span>;
  const cls = value === 'red' ? 'bg-danger' : value === 'yellow' ? 'bg-warning text-dark' : 'bg-success';
  return <span className={`badge ${cls}`}>{RYG_LABELS[value] || value}</span>;
}

/**
 * Final review screen summarizing all answers before submission.
 */
export default function StepReview({ formData }) {
  const contact = formData?.contact || {};
  const accounts = formData?.accounts_beneficiaries || {};
  const portfolio = formData?.portfolio_monitoring || {};

  return (
    <div>
      <SectionHeader number="" title="Review Your Answers" showAnnualNote={false} />
      <div className="cashflow-section-card">
        <h6 className="cashflow-subsection-title">Contact</h6>
        <p className="mb-1"><strong>Name:</strong> {contact.name || '—'}</p>
        <p className="mb-1"><strong>Email:</strong> {contact.email || '—'}</p>
        <p className="mb-1"><strong>Phone:</strong> {contact.phone || '—'}</p>
        <p className="mb-0">
          <strong>Shares finances with partner/spouse:</strong>{' '}
          {contact.shares_finances === 'yes' ? `Yes (${contact.partner_name || 'name not given'})` : 'No'}
        </p>
      </div>

      <div className="cashflow-section-card">
        <h6 className="cashflow-subsection-title">Accounts & Beneficiaries</h6>
        <p className="mb-1">
          <strong>Added investment account(s):</strong> {accounts.added_investment_accounts === 'yes' ? 'Yes' : 'No'}
        </p>
        <p className="mb-0">
          <strong>Beneficiaries changed:</strong> {accounts.beneficiaries_changed === 'yes' ? 'Yes' : 'No'}
        </p>
      </div>

      <div className="cashflow-section-card">
        <h6 className="cashflow-subsection-title">Wellness Check</h6>
        <p className="mb-1 d-flex align-items-center gap-2">
          <strong>Risk awareness:</strong> {rygBadge(formData?.risk_awareness?.answer)}
        </p>
        <p className="mb-1 d-flex align-items-center gap-2">
          <strong>Investment alignment:</strong> {rygBadge(formData?.investment_alignment?.answer)}
        </p>
        <p className="mb-1 d-flex align-items-center gap-2">
          <strong>Growth satisfaction:</strong> {rygBadge(formData?.growth_satisfaction?.answer)}
        </p>
        <p className="mb-0 d-flex align-items-center gap-2">
          <strong>Investment care:</strong> {rygBadge(formData?.investment_care?.answer)}
        </p>
      </div>

      <div className="cashflow-section-card">
        <h6 className="cashflow-subsection-title">Portfolio Monitoring</h6>
        <p className="mb-0">
          <strong>Check frequency:</strong> {PORTFOLIO_LABELS[portfolio.check_frequency] || portfolio.check_frequency || '—'}
        </p>
      </div>

      <p className="text-muted small mt-3">
        Everything look right? Click <strong>Submit</strong> below to send your answers to your advisor.
      </p>
    </div>
  );
}
